import React, {createContext, useContext} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import {FormikProvider, useFormik} from "formik";
import * as actions from '../../_redux/actions/OrdersPageTableActions';

const PopupEditTotalPaymentContext = createContext('');

export function usePopupEditTotalPaymentContext() {
  return useContext(PopupEditTotalPaymentContext);
}

export function PopupEditTotalPaymentContextProvider({children, totalPayment, orderID, handleCloseModal}) {
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(actions.editTotalPayment({
      orderID,
      totalPayment: formik.values.totalPayment,
    }));
    handleCloseModal();
  }

  const formik = useFormik({
    initialValues: {totalPayment},
    onSubmit: () => {},
    validateOnMount: true,
    validateOnBlur: true,
    enableReinitialize: true,
  });

  return (
    <PopupEditTotalPaymentContext.Provider value={{formik, handleEdit, handleCloseModal}}>
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </PopupEditTotalPaymentContext.Provider>
  );
}

PopupEditTotalPaymentContextProvider.propTypes = {
  children: PropTypes.node,
};
